import Icon from '../../components/Icon.vue'

Icon.register({"brands/telegram":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM369.8 177.9L329.1 369.7C326.1 383.3 318 386.6 306.7 380.2L244.7 334.5 214.8 363.3C211.5 366.6 208.7 369.4 202.3 369.4L206.7 306.3 321.6 202.5C326.6 198.1 320.5 195.6 313.9 200L171.9 289.4 110.7 270.3C97.4 266.1 97.1 257 113.5 250.6L352.6 158.4C363.7 154.4 373.4 161.1 369.8 177.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/telegram.js
// module id = oGZx
// module chunks = 0